// Fórmula única de un plan de pagos. Es la misma que usa el cotizador
// (Cotizador.js / Inventario.js): los descuentos se aplican en cadena
// (primero preventa, luego plan), las mensualidades reparten SOLO el
// porcentaje "durante la obra" y el resto se paga a la entrega.
// mesesOverride: meses reales a la fecha de entrega de la unidad; si no
// se manda, se usan los meses_plan del plan.
export const calcularPlan = (plan, precio, mesesOverride) => {
  const precioConPreventa = precio * (1 - plan.descuento_preventa / 100);
  const precioConDescuento = precioConPreventa * (1 - plan.descuento_plan / 100);
  const enganche = precioConDescuento * plan.enganche / 100;
  const duranteObra = precioConDescuento * plan.durante_obra / 100;
  const restoPorc = 100 - plan.enganche - plan.durante_obra;
  const entrega = precioConDescuento * restoPorc / 100;
  const mesesUsados = mesesOverride > 0 ? mesesOverride : plan.meses_plan;
  const mensualidad = mesesUsados > 0 ? duranteObra / mesesUsados : 0;
  const ahorro = precio - precioConDescuento;
  return { precioConDescuento, enganche, duranteObra, mensualidad, ahorro, entrega, restoPorc, mesesUsados };
};
